import { defineSlotRecipe } from '@chakra-ui/react';

export const numberInputSlotRecipe = defineSlotRecipe({
  className: 'chakra-number-input',
  slots: ['root', 'control', 'input'],
  base: {
    root: {
      rounded: 'none',
      border: '2px solid',
      borderColor: 'neutral.black',
      width: '100%',
      height: '48px',
      paddingX: 2,
      color: 'neutral.white',
      backgroundColor: 'neutral.800',
      _hover: {
        borderColor: 'skyBlue',
        background: 'neutral.700',
        _disabled: {
          borderColor: 'neutral.black',
          backgroundColor: 'neutral.800',
        },
        _invalid: {
          backgroundColor: 'red.800',
        },
      },
      _focus: {
        borderColor: 'skyBlue',
      },
      _invalid: {
        borderColor: 'red',
        backgroundColor: 'red.800',
      },
      _disabled: {
        cursor: 'default',
      },
    },
    control: {
      borderRadius: 0,
      border: 'none',
      boxShadow: 'none',
    },
    input: {
      flex: 1,
      textAlign: 'left',
      border: 'none',
      outline: 'none !important',
      boxShadow: 'none',
      _focus: {
        border: 'none',
        boxShadow: 'none',
      },
      _disabled: {
        cursor: 'default',
      },
    },
  },
});
